<template>
  <SplitContainer3 style="height:100%" :layout="12">
    <template #main>
      <TableMain name="myName" ref="PurchaseOrderTable1" :fields="fields" :title="table_title.title1"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_date_picker="true"
        :show_toolbar="false" :show_filter="true" :selectable="true" :isBusy="isBusy_table1"
        :hb_table_class="'hb_table_PurchaseOrder_class1'" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke" @current_changed="current_changed" tableref="88caecb2cc794fcf9766e9f7820fe7f5">
        <template #query>
          {{ $t("common.provider") + $t("common.num") }}：<el-input clearable size="small" style="width: 100px"
            v-model="OrderAccount"></el-input>
          {{ $t("common.provider") + $t("common.num") }}：<el-input clearable size="small" style="width: 120px"
            v-model="OrderAccountName"></el-input>
        </template>
      </TableMain>
    </template>
    <template #top>
      <TableMain ref="PurchaseOrderTable2" :fields="itemfields" :show_query_container="false" :show_toolbar="false"
        :title="table_title.title2" :date_picker_label="date_picker_label" :table_height_adjust="12"
        :show_filter="false" :isBusy="isBusy_table2" :hb_table_class="'hb_table_PurchaseOrder_class2'"
        :check_state="true" @current_changed="query_delivery_plan" tableref="e403f8c720a04a8d8f253bc672ff4ca9">
      </TableMain>
    </template>
    <template #bottom>
      <TableMain ref="DeliveryPlanRef" :fields="delivery_plan_fileds" :isBusy="isBusy_table3"
        :show_query_container="false" :title="table_title.title3" :date_picker_label="date_picker_label"
        :table_height_adjust="-1" :show_filter="false" :show_pagination="show_pagination" :pager_count="5"
        :loading_width="85" @state_change="table3_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]" tableref="966f24deb36942d5b3adbccf8d6500d3">
        <template #toolbar="">
          <el-button type="info" plain style="width: 55px" class="ml-2" @click="AddDelivery"><i
              class="fa fa-plus"></i></el-button>
          <div style="display: inline-block">
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" accept=".xlsx"
              :on-exceed="exceed" :limit="1" :on-remove="remove" :http-request="uploadFile"
              :before-upload="beforeFileUpload" :show-file-list="false" :file-list="fileList" :on-success="successFile">
              <el-button plain type="info" style="width: 55px" class="ml-2"><i
                  class="iconfont icon-export-in"></i></el-button>
            </el-upload>
          </div>
          <!-- <a href="" class="ml-2 mb-0">模板下载</a> -->
          <el-tooltip content="模板下载" placement="top" effect="light">
            <el-button plain type="info" style="width: 55px" @click="downloadTemplate" class="ml-2"><i
                class="iconfont icon-template"></i>
            </el-button>
          </el-tooltip>
        </template>
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveDelivery"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </template>
  </SplitContainer3>
</template>

<script>
// import axios from "axios"
// -- import * as _ from "lodash-es"
import { Split } from "view-design"
import "view-design/dist/styles/iview.css"
import XLSX from "xlsx"
import * as PurchaseOrderController from "../../controllers/mm/PurchaseOrderController"
import * as base_url from "../../shared/base_url"
import BaseContainer from "../components/BaseContainer"
import EntityEditor from "../components/base/EntityEditor"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer3 from "../components/container/SplitContainer3"
import TableDetail from "../components/table/TableDetail"
import TableMain from "../components/table/TableMain"

export default {
  name: "PurchaseOrder",
  components: {
    QueryButton,
    TableDetail,
    TableMain,
    TestQueryPanel,
    BaseContainer,
    EntityEditor,
    Split,
    SplitContainer3,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_purch_order",
        title2: "table_purch_order_detail",
        title3: "table_forecast_delivery_plan",
      },
      fields: _.cloneDeep(PurchaseOrderController.fields.delivery_plan_default),
      itemfields: _.cloneDeep(PurchaseOrderController.fields.item_fields),
      delivery_plan_fileds: _.cloneDeep(PurchaseOrderController.fields.delivery_plan_fileds),
      isBusy_table1: false,
      isBusy_table2: false,
      isBusy_table3: false,
      show_pagination: false,
      OrderAccount: "",
      OrderAccountName: "",
      selected1: null,
      selected2: null,
      selected3: null,
      fileList: [],
      base_url: base_url.base_url,
    }
  },
  activated() { },
  deactivated() { },
  computed: {},

  methods: {
    downloadTemplate() {
      window.location.href =
        this.base_url + "/excel_template/" + "供应商交货计划导入模板20240802.xlsx"
    },
    //上传1个以上文件时弹窗提示错误
    exceed: function () {
      // this.$message.error("最多只能上传1个xls文件");
      this.msgToasts("最多只能上传1个xls文件!", "info")
    },
    //删除
    remove() { },
    successFile() {
      //this.isBusy_table3 = false
    },
    //解析excel
    async uploadFile(params) {
      this.isBusy_table3 = true
      let _this = this
      let _file = params.file
      let fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          let data = ev.target.result
          let workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true,
          })
          let fields = []
          let listTable = []
          for (let sheet in workbook.Sheets) {
            if (sheet.indexOf("参考表") > -1) {
              continue
            }

            let sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
              defval: "",
            })
            if (sheetArray.length == 0) {
              continue
            }

            let _tmpModel = [
              {
                value: "PurchId",
                key: "采购订单号",
              },
              {
                value: "LineNumber",
                key: "采购订单行号",
              },
              {
                value: "OrderAccount",
                key: "供应商编号",
              },
              {
                value: "PurchQty",
                key: "采购数量",
              },
              {
                value: "DeliveryQty",
                key: "交货数量",
              },
              {
                value: "DeliveryDate",
                key: "交货日期",
              },
              {
                value: "Remark",
                key: "交货备注",
              },
            ]
            for (var _fm in _tmpModel) {
              let _field_model = { key: "", label: "" }
              let _key = _tmpModel[_fm].value
              let _label = _tmpModel[_fm].key
              _field_model.label = _label
              _field_model.key = _key
              fields.push(_field_model)
            }
            for (var i = 0, l = sheetArray.length; i < l; i++) {
              let _data = []
              for (var key in sheetArray[i]) {
                if (_.isDate(sheetArray[i][key])) {
                  sheetArray[i][key] = this.$date.addDays(
                    sheetArray[i][key],
                    1
                  )
                }
                _data.push({ key: key, value: sheetArray[i][key] })
              }
              let dif = _.differenceBy(_data, _tmpModel, "key")
              if (dif.length > 0) {
                // this.$message.warning("文件类型不正确！");
                this.msgToasts("文件类型不正确！!", "info")

                return
              }
            }
            listTable = sheetArray.map(function (o) {
              return {
                PurchId: o["采购订单号"],
                LineNumber: o["采购订单行号"],
                OrderAccount: o["供应商编号"],
                PurchQty: o["采购数量"],
                DeliveryQty: o["交货数量"],
                DeliveryDate: _this.$date.format(
                  new Date(o["交货日期"]),
                  "yyyy-MM-dd"
                ),
                Remark: o["交货备注"] ? o["交货备注"] : "",
              }
            })
            _this.$refs.DeliveryPlanRef.SetData(listTable)
            if (
              _this.$refs.DeliveryPlanRef.my_data &&
              _this.$refs.DeliveryPlanRef.my_data.length > 50
            ) {
              _this.show_pagination = true
            }
          }
        } catch (e) {
          console.log(e)
          // this.$message.warning("文件类型不正确！");
          this.msgToasts("文件类型不正确！!", "info")

          this.isBusy_table3 = false
        }
      }
      fileReader.readAsBinaryString(_file)
      this.isBusy_table3 = false
      this.fileList = []
    },
    //before上传
    beforeFileUpload() { },

    //状态改变
    table3_state_change(data, cb) {
      if (data.state === "deleted") {
        this.msgModal(this.$t("notify.is_deleted")).then(async (t) => {
          if (t) {
            let del_list = _.filter(data.selected_items, function (t) {
              return t.id != ""
            })
            if (del_list && del_list.length > 0) {
              let is_ok =
                await PurchaseOrderController.methods.deleteDeliveryPlan(
                  del_list
                )
              if (is_ok) {
                this.msgToasts(this.$t("notify.action_successfully"), "success")
                cb(true)
              } else {
                this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
              }
            } else {
              cb(true)
            }
          }
        })
      }
    },

    //保存交货计划
    async saveDelivery(cb) {
      let _this = this
      if (this.$refs.DeliveryPlanRef.my_data.length == 0) {
        cb(true)
        return
      }
      //数据检测
      let _is_check_ok = this.validData(this.$refs.DeliveryPlanRef.my_data)
      if (!_is_check_ok) {
        cb(true)
        return
      }
      //新增or修改
      let add_list = []
      let update_list = []
      let data = _.cloneDeep(this.$refs.DeliveryPlanRef.my_data)
      for (var i in data) {
        let _m = _.cloneDeep(PurchaseOrderController.dataDeliveryForm)
        _m.id = ""
        _m.PurchId = data[i].PurchId.trim()
        _m.LineNumber = data[i].LineNumber
        _m.OrderAccount = data[i].OrderAccount.toString().trim()
        _m.PurchQty = data[i].PurchQty
        _m.DeliveryQty = data[i].DeliveryQty
        _m.DeliveryDate = _this.$date.format(
          new Date(data[i].DeliveryDate),
          "yyyy-MM-dd"
        )
        _m.Remark = data[i].Remark
        if (!data[i].id) {
          add_list.push(_m)
        } else {
          _m.id = data[i].id
          update_list.push(_m)
        }
      }
      let result = await PurchaseOrderController.methods.saveDeliveryPlan(
        add_list,
        update_list
      )
      if (!_.isNull(result)) {
        ///成功
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        let purch_order_line = this.$refs.PurchaseOrderTable2.GetCurrentItem()
        if (purch_order_line) {
          let _result =
            await PurchaseOrderController.methods.getDeliveryPlanItems({
              PurchId: { "=": this.selected1.PurchId },
              LineNumber: { "=": purch_order_line.LineNumber },
              is_deleted: { "=": 0 },
            })

          if (!_.isNull(_result) && _result && _result.length > 0) {
            this.$refs.DeliveryPlanRef.SetData(
              _.orderBy(_result[0], ["LineNumber"], ["asc"])
            )
          }
        }
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
      cb(true)
    },
    //数据检测
    validData(data) {
      ///检查是否重复交货日期
      let _is_qty_ok = true
      _.each(data, (t) => {
        t.DeliveryDate = this.$date.format(
          new Date(this.formatDate(t.DeliveryDate)),
          "yyyy-MM-dd"
        )
        if (
          t.DeliveryQty == "" ||
          _.isNull(t.DeliveryQty) ||
          parseFloat(t.DeliveryQty) == 0
        ) {
          _is_qty_ok = false
        }
      })
      if (!_is_qty_ok) {
        this.msgToasts(this.$t("notify.not_pcs"), "info")
        return _is_qty_ok
      }
      let _cd = _.groupBy(data, "DeliveryDate")
      let _is_repeat = false
      for (var i in _cd) {
        if (_cd[i].length > 1) {
          _is_repeat = true
          break
        }
      }
      if (_is_repeat) {
        this.msgToasts(this.$t("notify.delivery_date_exist"), "info")
        return !_is_repeat
      }
      //按单号拆分
      // 删除采购单号中的空格
      for (var i in data) {
        data[i].PurchId = data[i].PurchId.trim()
      }
      let _this = this
      let _bool = true
      let arr = _.groupBy(data, "PurchId")
      for (var i in arr) {
        let sum = _.sumBy(arr[i], "DeliveryQty")
        if (sum > arr[i][0].PurchQty) {
          this.msgToasts(this.$t("notify.plan_pcs_not_more_dispatch_pcs"), "error")
          _bool = false
        }
        // if (_this.selected2) {
        //   for (var j in arr[i]) {
        //     if (
        //       new Date(arr[i][j].DeliveryDate).getTime() >
        //       new Date(_this.selected2.DeliveryDate).getTime()
        //     ) {
        //       this.msgToasts("计划日期不能超过交期", "error");
        //       _bool = false;
        //       return;
        //     }
        //   }
        // }
      }

      return _bool
    },
    //
    async DeliveryChoose() {
      let _this = this
      let _append_items = []

      let _m = _.cloneDeep(PurchaseOrderController.dataDeliveryForm)
      _m.id = ""
      _m.PurchId = _this.selected1.PurchId //采购单号
      _m.LineNumber = _this.selected2.LineNumber //行号
      _m.OrderAccount = _this.selected1.OrderAccount //销售订单明细
      _m.PurchQty = _this.selected2.PurchQty //采购单数量
      _m.DeliveryQty = 0
      _m.DeliveryDate = _this.$date.format(new Date(), "yyyy-MM-dd")
      _m.Remark = ""

      _append_items.push(_m)

      if (this.$refs.DeliveryPlanRef.my_data.length > 0) {
        this.$refs.DeliveryPlanRef.AppendItems(_append_items)
      } else {
        this.$refs.DeliveryPlanRef.SetData(_append_items)
      }
      if (
        this.$refs.DeliveryPlanRef.my_data &&
        this.$refs.DeliveryPlanRef.my_data.length > 50
      ) {
        this.show_pagination = true
      }
    },
    //新增交期计划
    AddDelivery() {
      if (this.selected2 && !_.isNull(this.selected2)) {
        this.DeliveryChoose()
      } else {
        this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }
    },
    ///查询
    async on_query(set_data, date_range) {
      this.isBusy_table1 = true
      this.selected2 = null
      this.selected1 = null
      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = {
        OrderAccountName: this.OrderAccountName,
      }
      if (this.OrderAccount != "") {
        _params.OrderAccount = this.OrderAccount
      }
      if (
        !_.isNull(date_range) &&
        this.OrderAccount == "" &&
        this.OrderAccountName == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _params["fromDate"] = _fromDate
        _params["toDate"] = _toDate
      }
      let _result = await PurchaseOrderController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]))
      }
      this.isBusy_table1 = false
    },
    state_change(data, cb) { },
    tool_invoke(data) { },
    async current_changed(old, current) {
      this.selected2 = null
      if (_.isNull(current)) {
        this.$refs.PurchaseOrderTable2.SetData([])
        return
      }
      this.selected1 = current
      this.isBusy_table2 = true

      let _result = await PurchaseOrderController.methods.getItemData({
        PurchaseOrderId: current.id,
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.PurchaseOrderTable2.SetData(
          _.orderBy(_result[0], ["LineNumber"], ["asc"])
        )
      }

      this.isBusy_table2 = false
    },
    async query_delivery_plan(old, current) {
      if (_.isNull(current)) {
        this.$refs.DeliveryPlanRef.SetData([])
        return
      }
      this.selected2 = current
      this.isBusy_table3 = true
      let _result = await PurchaseOrderController.methods.getDeliveryPlanItems({
        PurchId: { "=": this.selected1.PurchId },
        LineNumber: { "=": current.LineNumber },
        is_deleted: { "=": 0 },
      })

      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.DeliveryPlanRef.SetData(
          _.orderBy(_result[0], ["LineNumber"], ["asc"])
        )
      }
      this.isBusy_table3 = false
    },
  },
}
</script>
<style>
.hb_table_PurchaseOrder_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}

.hb_table_PurchaseOrder_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 80rem;
}
</style>

<style scoped>
.one_table>>>.hb_table_query_container_one_table {
  background-color: white;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_thead>.hb_thead_tr>.b-table-sticky-column.hb_thead_th_name {
  left: 21px;
}

.hb_table_panel_container_myName>>>.b-table-sticky-header>.table.b-table>.hb_tbody>.hb_tbody_tr>.b-table-sticky-column.hb_tbody_td_name {
  left: 21px;
}
</style>
